// eventBus.js
export const EventBus = {
  events: {},

  $on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = []
    }
    this.events[event].push(callback)
  },

  $emit(event, data) {
    if (this.events[event]) {
      this.events[event].forEach(callback => callback(data))
    }
  },

  $off(event, callback) {
    if (!this.events[event]) return
    if (!callback) {
      // 如果没有提供回调函数，则移除该事件的所有监听器
      delete this.events[event]
    } else {
      // 否则，仅移除指定的回调函数
      this.events[event] = this.events[event].filter(cb => cb !== callback)
    }
  }
}
